import { CustomSelect, Icons, SortDir } from "rujira.ui";

export function SortBar<K extends string>({
  options,
  sortKey,
  sortDir,
  onKeyChange,
  onDirToggle,
  label = "Sort",
}: {
  options: readonly { key: K; label: string }[];
  sortKey: K;
  sortDir: SortDir;
  onKeyChange: (key: K) => void;
  onDirToggle: () => void;
  label?: string;
}) {
  return (
    <div className="sort-bar flex ai-c gap-1 w-full">
      <span className="fs-12 condensed color-grey nowrap">{label}</span>
      <CustomSelect
        className="expand custom-select--sm"
        ariaLabel={label}
        value={sortKey}
        options={options}
        onChange={onKeyChange}
      />
      <button
        type="button"
        aria-label={
          sortDir === SortDir.Asc ? "Sort ascending" : "Sort descending"
        }
        className="sort-bar__direction flex ai-c jc-c pointer"
        onClick={onDirToggle}>
        {sortDir === SortDir.Asc ? (
          <Icons.AngleUp className="w-1.5 h-1.5" />
        ) : (
          <Icons.AngleDown className="w-1.5 h-1.5" />
        )}
      </button>
    </div>
  );
}
